import api from "./api";

function adminUrl(path) {
    const baseURL = api.defaults.baseURL || window.location.origin;
    return new URL(`../admin/${String(path || "").replace(/^\/+/, "")}`, baseURL).toString();
}

function dataOf(response) {
    return response?.data?.data ?? response?.data ?? null;
}

// Existing Strapi roles are read only. Support permissions are stored by
// the dedicated support-access endpoints and never update Strapi RBAC.
export async function fetchAdminRoles() {
    return dataOf(await api.get(adminUrl("roles"))) || [];
}

export async function fetchSupportRoleAccess() {
    return dataOf(await api.get(adminUrl("support-access/roles"))) || {
        roleAccess: {},
        catalog: [],
    };
}

export async function updateSupportRoleAccess(roleId, permissions) {
    return dataOf(await api.put(adminUrl(`support-access/roles/${roleId}`), {
        permissions,
    }));
}

export async function fetchOwnSupportPermissions() {
    const payload = dataOf(await api.get(adminUrl("support-access/me"))) || {};
    return Array.isArray(payload.permissions) ? payload.permissions : [];
}

export async function fetchUserSessions(userDocumentId) {
    return dataOf(await api.get(adminUrl(`support-access/users/${userDocumentId}/sessions`))) || [];
}

export async function revokeUserSession(userDocumentId, sessionDocumentId, verificationNote, phoneVerified) {
    return dataOf(await api.post(adminUrl(`support-access/users/${userDocumentId}/sessions/${sessionDocumentId}/revoke`), {
        verificationNote,
        phoneVerified,
    }));
}

export async function recoverUserAccess(userDocumentId, payload) {
    return dataOf(await api.post(adminUrl(`support-access/users/${userDocumentId}/recover-access`), payload));
}

export async function fetchPlanEditor(documentId = null) {
    const path = documentId
        ? `billing-domain/plans/${documentId}/editor`
        : "billing-domain/plans/editor/catalog";
    return dataOf(await api.get(adminUrl(path)));
}

export async function fetchDetailedPlans() {
    return dataOf(await api.get(adminUrl("billing-domain/plans/detailed"))) || [];
}

export async function resetPlanCatalogDefaults() {
    return dataOf(await api.post(adminUrl("billing-domain/plans/reset-defaults"))) || [];
}

export async function savePlanEditor(
    documentId,
    plan,
    entitlements,
    marketingFeatures,
    customizations = []
) {
    const payload = {plan, entitlements, marketingFeatures, customizations};
    return dataOf(documentId
        ? await api.put(adminUrl(`billing-domain/plans/${documentId}`), payload)
        : await api.post(adminUrl("billing-domain/plans"), payload));
}

export async function fetchPlanPriceEditor(documentId) {
    return dataOf(await api.get(adminUrl(`billing-domain/plans/${documentId}/prices/editor`)));
}

export async function savePlanPriceList(documentId, prices) {
    return dataOf(await api.put(adminUrl(`billing-domain/plans/${documentId}/prices`), {prices}));
}

export async function createFreeWorkspaceSubscription(workspaceDocumentId) {
    return dataOf(await api.post(adminUrl("billing-domain/subscriptions/free"), {
        workspaceDocumentId,
    }));
}

export async function activateWorkspaceSubscription(documentId, workspaceDocumentId) {
    return dataOf(await api.post(adminUrl(`billing-domain/subscriptions/${documentId}/activate`), {
        workspaceDocumentId,
    }));
}

export async function cancelWorkspaceSubscription(documentId, workspaceDocumentId, immediate = false) {
    return dataOf(await api.post(adminUrl(`billing-domain/subscriptions/${documentId}/cancel`), {
        workspaceDocumentId,
        immediate,
    }));
}

// «مدیریت اشتراک»: remaining time, plan, extra member capacity (zofino-strapi src/billing/subscription-admin.ts)
export async function getSubscriptionAdjustment(documentId) {
    return dataOf(await api.get(adminUrl(`billing-domain/subscriptions/${encodeURIComponent(documentId)}/adjust`)));
}

export async function adjustSubscription(documentId, change) {
    return dataOf(await api.post(adminUrl(`billing-domain/subscriptions/${encodeURIComponent(documentId)}/adjust`), change));
}
